import React, { useState, useContext, useEffect } from "react";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";
import "./AddProducts.css";
import Papa from "papaparse";
import { useLocation } from "react-router-dom";

const UploadProduct = () => {
  const { token } = useContext(AuthContext);

  const [productsCount, setProductsCount] = useState(0);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // Progress state
  const location = useLocation();
  const [file, setFile] = useState(null);

  // Determine the active class based on the current route
  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  // useEffect(() => {
  //     fetchProducts();
  // }, []);

  const changeHandler = (event) => {
    const file = event.target.files[0];
    setFile(file);

    // Calculate total number of rows in CSV
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (result) => {
        setProductsCount(result.data.length - 1); // Subtracting header row
      },
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setIsLoadingUpload(true);
    setUploadProgress(0);

    try {
      const formData = new FormData();
      formData.append("file", file);

      await axios.post("/product_insert_from_csv", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      });

      setIsLoadingUpload(false);
      alert(`Products Uploaded Successfully: ${productsCount} Products`);
      setProductsCount(0);
    } catch (error) {
      console.error(error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        alert(`Error uploading file: ${error.response.data.message}`);
      } else {
        alert("Error uploading file");
      }
      setIsLoadingUpload(false);
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="importModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="importModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-scrollable modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="importModalLabel">
                Import Products
              </h5>
              <button
                type="button"
                className="close btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {isLoadingUpload ? (
                <div className="progress mb-3">
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow={uploadProgress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                </div>
              ) : (
                <form onSubmit={handleFormSubmit} className="w-100 p-0">
                  <div className="row">
                    <div className="col-12">
                      <div className="upload-product w-100">
                        <h4>Upload CSV file here</h4>
                        <input
                          type="file"
                          name="file"
                          accept=".csv"
                          onChange={changeHandler}
                        />
                        <button type="submit" className="btn btn__primary mb-3">
                          Add Products
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}

              <div className="col-sm-12">
                <h4 className="mb-4">
                  {!isLoadingUpload
                    ? `${productsCount} Products Will Get Uploaded`
                    : `Products Uploaded: ${productsCount} Products`}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadProduct;
